<script lang="ts">
      import '../app.css'
      import Footer from '../lib/components/footer/Footer.svelte'
      import Header from '$lib/components/header/Header.svelte'
      import GlobalContext from '$lib/components/context/GlobalContext.svelte'
      import Debug from '$lib/components/context/Debug.svelte'
      import { NavigationItem } from '$lib/components/menu/Menu.d'
      import { z } from 'zod'
      import { createPayloadContext } from '$lib/components/context/ts/PayloadGlobals.svelte'
      import { createLivePreviewContext } from '$lib/components/context/ts/LivePreview.svelte'
      import BodyContext from '$lib/components/context/BodyContext.svelte'
      import MenuBlock from '$lib/components/menu/side/MenuBlock.svelte'
      import Cookiebar from '$lib/components/cookiebar/Cookiebar.svelte'
      import Analytics from '$lib/components/cookiebar/Analytics.svelte'
      import Lightroom from '$lib/components/gallery/Lightroom.svelte'
      import { createLocaleContext } from '$lib/components/locale/ts/Locale.svelte'
      import { untrack } from 'svelte'
      import { createMetaContext } from '$lib/components/metatags/ts/MetaContext.svelte'
      import Metatags from '$lib/components/metatags/Metatags.svelte'

      let { data, children } = $props()

      const payloadContext = createPayloadContext()
      const livePreview = createLivePreviewContext()
      const locale = createLocaleContext('cs')
      const meta = createMetaContext()

      //livePreview.setLivePreviewType({ livePreview: data.livePreview })

      function livePreviewOnChange(data: any) {
            const { navigation, footer } = data
            const { data: navigationValidation, error: navigationError } = z.array(NavigationItem).safeParse(data.navigation)
            if (!navigationError) payloadContext.setNavigation(navigationValidation)
            payloadContext.setFooter
      }

      async function setup() {
            const { data: navigation, error: navigationError } = z.array(NavigationItem).safeParse(data.navigation)

            if (!navigationError) payloadContext.setNavigation(navigation)
            else console.error(navigationError.message)

            payloadContext.setFooter(data.footer)
            payloadContext.setLivePreview(data.livePreview)
            payloadContext.setSeo(data.seo)
            payloadContext.setSocials(data.socials)
            livePreview.setLivePreviewType({ livePreview: data.livePreview })
            livePreview.registerLivePreview({ livePreview: 'config', onChange: livePreviewOnChange, initialData: data.rawGlobalData })
            locale.setLocale(data.locale)
      }

      $effect(() => {
            data
            untrack(() => {
                  setup()
            })
      })

      setup()
</script>

<GlobalContext>
      <Debug>
            <Analytics>
                  <Cookiebar></Cookiebar>
            </Analytics>
            <Lightroom>
                  <BodyContext>
                        <Header></Header>
                        <div class="min-h-full flex flex-col">
                              {@render children?.()}
                        </div>
                        <Footer></Footer>

                        {#snippet after()}
                              <MenuBlock></MenuBlock>
                        {/snippet}
                  </BodyContext>
            </Lightroom>
      </Debug>
</GlobalContext>
<Metatags></Metatags>

<style>
</style>
